import SectionHeader from "@/components/SectionHeader";
import { Reveal } from "@/components/motion";
import { FAQS } from "@/data/site";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQAccordion({ showHeader = true }) {
  return (
    <section className="bg-white py-20 lg:py-28" data-testid="faq-section" id="faq">
      <div className="dq-container">
        {showHeader && (
          <SectionHeader
            center
            eyebrow="Questions"
            title="Frequently asked"
            highlight="questions"
            subtitle="Everything you need to know before working with us."
          />
        )}
        <Reveal delay={0.1}>
          <div className="mx-auto mt-12 max-w-3xl">
            <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="overflow-hidden rounded-2xl border border-dq-line bg-dq-bg px-5 data-[state=open]:bg-white data-[state=open]:dq-shadow-soft"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="py-5 text-left font-display text-base font-bold text-dq-ink hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-[15px] leading-relaxed text-dq-muted">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
